<script lang="ts">
  import type { AuthState } from '../lib/auth.svelte';
  let { auth }: { auth: AuthState } = $props();
</script>

<main class="login-shell">
  <section class="login-card" aria-label="Staff sign in">
    <img class="brand-mark" src="/corrected-cloud-logo.svg" alt="Corrected Cloud" />
    {#if auth.status === 'error'}<p class="inline-error" role="alert">{auth.message}</p>{/if}
    <button class="primary" onclick={() => auth.signIn()}>Sign in with Google Workspace</button>
  </section>
</main>
